import Navbar from '../../components/navbars/Navbar'
import './about.css'
import kirkSurberHeadshot from '../../assets/images/KSheadshot.jpg'
import { MdTimelapse } from "react-icons/md";
import { FaLayerGroup } from "react-icons/fa";
import { BsLightningChargeFill } from "react-icons/bs";
import VideoCarousel from '../../components/videoSection/VideoCarousel';

export const metadata = {
    title: 'About | Albums and Art',
    keywords: 'Photo Albums, Wall Art, Custom Prints, Handmade Albums',
    description: 'Albums and Art turns your photos into stunning albums and wall art, made just for you.'
}

export default function About() {

    const data = [
        `https://albums-and-art-product.s3.us-east-1.amazonaws.com/Albums/Lux/video-clips/Album-Covers-Video-Pan.mp4`,
        `https://albums-and-art-product.s3.us-east-1.amazonaws.com/Albums/Lux/video-clips/Lux-Photo-Albums-and-covers.mp4`,
        `https://albums-and-art-product.s3.us-east-1.amazonaws.com/Albums/Lux/video-clips/Lux-Photo-Albums-pages-layflat.mp4`
    ]
    return (
        <div>
            <Navbar />
            <div className='aboveTheFold'>

            
            {/* Hero Section */}
            <section className='hero'>
                <h1>Bring Your Memories to Life - Beyond the Screen</h1>
                <p>Custom-Crafted Albums & Wall Art, Made for You.</p>
            </section>
            <VideoCarousel 
                data={data}
            />

            {/* Mission Section */}
            <section className='mission'>
                <h2>Our Mission</h2>
                <p>We turn your favorite photos into high-quality albums and wall art, transforming digital memories into lasting keepsakes you can see, hold, and enjoy every day.</p>
            </section>

            {/* How It Works */}
            <section className='howItWorks'>
                <h2>How It Works</h2>
                <div id='steps'>
                    <div className='step'>
                        <MdTimelapse size={40} className='icon' />
                        <h4>Pick Your Album or Wall Art</h4>
                        <p>Choose from beautiful albums or prints for your home.</p>
                    </div>
                    <div className='step'>
                        <FaLayerGroup size={40} className='icon' />
                        <h4>Upload Your Photos</h4>
                        <p>Use your "My Orders" page to send us your pictures.</p>
                    </div>
                    <div className='step'>
                        <BsLightningChargeFill size={40} className='icon' />
                        <h4>We Create & Ship</h4>
                        <p>Our team designs, prints, and ships your order right to you.</p>
                    </div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className='whyChooseUs'>
                <h2>Why Choose Albums and Art?</h2>
                <div className='features'>
                    <div className='feature'>
                        <h4>Handmade with Care</h4>
                        <p>Our albums and prints are crafted in the USA with high-quality materials.</p>
                    </div>
                    <div className='feature'>
                        <h4>Designed for You</h4>
                        <p>We offer free album design and a team to help edit your photos.</p>
                    </div>
                    <div className='feature'>
                        <h4>Fast & Easy</h4>
                        <p>Upload your photos, and we’ll take care of the rest!</p>
                    </div>
                </div>
            </section>
            {/* Our Values */}
            <section className='values'>
                <h2>What Matters to Us</h2>
                <ul>
                    <li><strong>Quality</strong> – Every album and print is made to last a lifetime.</li>
                    <li><strong>Easy for You</strong> – We do all the hard work so you don’t have to.</li>
                    <li><strong>Memories That Last</strong> – Your photos deserve more than a screen!</li>
                </ul>
            </section>


            {/* Founder Section */}
            <section className='owner'>
                <h2>Meet the Founder</h2>
                <div className='ownerContent'>
                    <img alt='Founder' src={kirkSurberHeadshot} className='ownerPhoto'/>
                    <p>I picked up photography being away from my children and realizing I wanted moments to remmember them by.  Having been deployed to Iraq in 04', 06'-07' and to Afghanistan as a contractor for several years.  Having photos of your loved ones is more valuable than anything else I can own.  I've built Albums and Art to help people who have images on their phones and computers to put them into quality, hand-crafted albums and wall-art to place in your home.  One of the best feelings is walking into your home and seeing a captured moment of your loved one as you walk in the door to your home or office.</p>
                </div>
            </section>

            
            </div>
        </div>
    )
}
